import {
  encodeContext
} from "./../helpers/composables.js";
import { buildRequestParams } from "./../helpers/index.js";
import { performRequest } from "./nuxtApp.js";
import { clientOptions } from "#graphql-middleware-client-options";
export function useGraphqlQuery(...args) {
  const [
    name,
    variables,
    fetchOptions = {},
    graphqlCaching = {},
    overrideClientContext = {}
  ] = typeof args[0] === "string" ? [
    args[0],
    args[1],
    args[2]?.fetchOptions,
    args[2]?.graphqlCaching,
    args[2]?.clientContext
  ] : [
    args[0].name,
    args[0].variables,
    args[0].fetchOptions,
    args[0].graphqlCaching,
    args[0].clientContext
  ];
  const globalClientContext = clientOptions.buildClientContext ? clientOptions.buildClientContext() : {};
  return performRequest(
    "query",
    name,
    "get",
    {
      ...fetchOptions,
      params: {
        ...fetchOptions.params || {},
        ...buildRequestParams(variables),
        ...encodeContext({
          ...globalClientContext,
          ...overrideClientContext
        })
      }
    },
    graphqlCaching
  );
}
